/*
 *  saga to load auth user details from the just token
 */
import moment from 'moment'
import {
  put,
  takeLatest,
  takeEvery,
  fork,
  select,
  delay,
} from 'redux-saga/effects'
import { uniq } from 'lodash'

import { selectProjects } from '../../containers/Dashboard/selectors'
import { getAlerts, markAlertsAsRead, deleteAlert } from '../../utils/api'
import { isCity } from '../../utils/locations'
import { isSignedIn } from '../../utils/userAuth'
import {
  FETCH_ALERTS,
  MARK_ALERTS_AS,
  fetchAlertsSuccess,
  DELETE_ALERT,
} from '../actions/alerts'
import { getLocationsInfo } from '../actions/locationManager'
import { selectCachedLocations } from '../selectors/locationManager'
import { skipFetchAfterLoginDataPaths } from '../../utils/consts.mjs'
import history from '../../history'

export default function* alertsSaga() {
  yield fork(updateAlertsHandler)
  yield takeLatest(FETCH_ALERTS.action, (action) =>
    updateAlertsHandler(action.payload),
  )
  yield takeEvery(MARK_ALERTS_AS.action, (action) =>
    markAlertsHandler(action.payload),
  )
  yield takeEvery(DELETE_ALERT.action, (action) =>
    deleteAlertHandler(action.payload),
  )
}

export function mapAlertsFromProjects(alerts, projects) {
  const alertData = {
    data: alerts.map((alert) => {
      const project = projects.find((p) => p.id === alert.projectId)
      if (project) {
        alert.projectName = project.title
        alert.projectDomain = project.domain
      }
      return alert
    }),
  }
  return alertData
}

function* updateAlertsHandler(info) {
  try {
    if (
      !isSignedIn() ||
      skipFetchAfterLoginDataPaths.some((path) =>
        history.location.pathname.endsWith(path),
      )
    )
      return

    const alertResponse = yield getAlerts()
    const alerts = alertResponse.data

    let projects = yield select(selectProjects())
    while (projects === null) {
      yield delay(1000)
      projects = yield select(selectProjects())
    }
    const alertData = mapAlertsFromProjects(alerts, projects)
    if (info && info.alertType === 'site_audit_report_created') {
      const alert = alerts.find(
        (alertItem) =>
          alertItem.alertType === 'site_audit_report_created' &&
          alertItem.content.domain === info.domain &&
          !alertItem.seen &&
          moment().diff(moment(new Date(alertItem.date)), 'seconds') < 15,
      )
      if (alert) {
        alertData.siteAuditReportAlert = alert
      }
    }

    if (alerts && alerts.length > 0) {
      const cachedLocations = yield select(selectCachedLocations())
      const locIds = uniq(
        alerts
          .filter(
            (alert) =>
              alert.content?.project?.location &&
              isCity(alert.content.project.location) &&
              !cachedLocations[alert.content.project.location],
          )
          .map((alert) => alert.content.project.location),
      )

      if (locIds.length > 0) yield put(getLocationsInfo(locIds))
    }
    yield put(fetchAlertsSuccess(alertData))
  } catch (e) {
    console.warn(e)
  }
}

function* markAlertsHandler(payload) {
  try {
    yield markAlertsAsRead(payload)
    yield fork(updateAlertsHandler)
  } catch (e) {
    console.warn(e)
  }
}

function* deleteAlertHandler(payload) {
  try {
    yield deleteAlert(payload)
    yield fork(updateAlertsHandler)
  } catch (e) {
    console.warn(e)
  }
}
